import { callCoreApi } from "../../services/coreApi";


/**
 * Call Core API using the base URL from .env.development (REACT_APP_API_URL).
 *
 * @param {string} path - API path, e.g. "/api/auth/session"
 * @param {object} [options]
 * @param {string} [options.method="GET"]
 * @param {object|null} [options.body=null]
 * @param {object} [options.headers={}]
 * @param {string} [options.credentials="include"]
 * @returns {Promise<any>}
 */


export async function getClients() {
	const payload = await callCoreApi("/api/admin/clients", {
		method: "GET",
	});

	if (Array.isArray(payload)) {
		return payload;
	}

	if (Array.isArray(payload.clients)) {
		return payload.clients;
	}

	return [];
}

export async function handleClientInsert(clientData) {
	const payload = await callCoreApi("/api/admin/clients", {
		method: "POST",
		body: clientData,
	});

	return payload;
}

export async function handleClientUpdate(id, clientData) {
	const payload = await callCoreApi(`/api/admin/clients/${id}`, {
		method: "PATCH",
		body: clientData,
	});

	return payload;
}

export async function getProducts() {
	const payload = await callCoreApi("/api/admin/products", {
		method: "GET",
	});

	if (Array.isArray(payload)) {
		return payload;
	}

	if (Array.isArray(payload.products)) {
		return payload.products;
	}

	return [];
}

export async function handleProductInsert(productData) {
	const payload = await callCoreApi("/api/admin/products", {
		method: "POST",
		body: productData,
	});

	return payload;
}

export async function handleProductUpdate(id, productData) {
	const payload = await callCoreApi(`/api/admin/products/${id}`, {
		method: "PATCH",
		body: productData,
	});

	return payload;
}

export async function getEmployees() {
	const payload = await callCoreApi("/api/admin/employees", {
		method: "GET",
	});

	if (Array.isArray(payload)) {
		return payload;
	}

	if (Array.isArray(payload.employees)) {
		return payload.employees;
	}

	return [];
}

export async function handleEmployeeInsert(employeeData) {
	const payload = await callCoreApi("/api/admin/employees", {
		method: "POST",
		body: employeeData,
	});

	return payload;
}

export async function handleEmployeeUpdate(id, employeeData) {
	const payload = await callCoreApi(`/api/admin/employees/${id}`, {
		method: "PATCH",
		body: employeeData,
	});

	return payload;
}